(function($, _) {
  var ns = nspace("ccc.viz.map.util.ChartRenderer");

  ns.renderSparkline = function(
    chartContainer,
    xAxisCategories,
    dataSeries,
    displayValues,
    onAnimationCompleteCallback
  ) {
    return new Highcharts.Chart({
      chart: {
        renderTo: chartContainer,
        margin: [0, 0, 20, 0],
        backgroundColor: "rgba(0, 0, 0, 0)",
        borderWidth: 0
      },
      title: {
        text: null
      },
      credits: {
        enabled: false
      },
      xAxis: {
        maxPadding: 0.06,
        minPadding: 0.06,
        categories: xAxisCategories,
        endOnTick: true,
        lineWidth: 0,
        tickWidth: 0,
        labels: {
          enabled: true,
          align: "center",
          useHTML: true,
          formatter: function() {
            // Only show the first and last labels
            if (
              this.value === xAxisCategories[0] ||
              this.value === xAxisCategories[xAxisCategories.length - 1]
            ) {
              // We need to manually tweak the label positioning
              var style = "";
              if (this.value === xAxisCategories[0]) {
                style += " left: 10px;";
              }
              else {
                style += " right: 10px;";
              }

              return (
                "<div class='sparkline-label' style='" +
                style +
                "'>" +
                this.value +
                "</div>"
              );
            }
            return null;
          }
        }
      },
      yAxis: {
        maxPadding: 0.12,
        minPadding: 0.12,
        labels: {
          enabled: false
        },
        gridLineWidth: 0,
        title: null
      },
      legend: {
        enabled: false
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        borderWidth: 0,
        shadow: false,
        formatter: function() {
          return (
            "<div class='sparkline-tooltip'><span>" +
            this.x +
            ":</span> " +
            displayValues[this.x] +
            "</div>"
          );
        },
        style: {
          padding: 0
        },
        positioner: function(labelWidth, labelHeight, point) {
          return { x: point.plotX - labelWidth / 2, y: point.plotY - 50 };
        }
      },
      plotOptions: {
        series: {
          lineWidth: 2,
          shadow: false,
          states: {
            hover: {
              lineWidth: 2
            }
          },
          marker: {
            radius: 3,
            states: {
              hover: {
                radius: 4
              }
            }
          }
        }
      },
      series: [
        {
          color: "#FE3D34",
          data: dataSeries,
          animation: {
            complete: function() {
              if (onAnimationCompleteCallback) {
                onAnimationCompleteCallback();
              }
            }
          }
        }
      ]
    });
  };
})(jQuery, _);
